export const CURRENCIES = {
    USD: 1,
    EUR: 0.88,
    GBP: 0.78,
};
